import { type UseFormReturnType } from '@mantine/form';
import { useEffect } from 'react';
import { employeeDetailedToUpdateEmployee } from '@/schemas/converters/employeeSchemasConverter';
import { type EmployeeDetailed } from '@/schemas/API/GET/employee/response';
import { type UpdateEmployee } from '@/schemas/API/PUT/employee/request';

const useSyncFormWithEmployee = (
  employee: EmployeeDetailed | undefined,
  employeeForm: UseFormReturnType<UpdateEmployee>
) => {
  useEffect(() => {
    if (!employee) return;

    const employeeUpdate = employeeDetailedToUpdateEmployee(employee);
    employeeForm.setValues(employeeUpdate);
  }, [employee]);
};

export default useSyncFormWithEmployee;
